import TypeAhead from "./TypeAhead";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";

import { compose } from "recompose";

const enhance = compose(withStyles(styles, { withTheme: true }));
export default enhance(TypeAhead);
